import _defaultApi from '@/utils/request';

const defaultApi = _defaultApi;

export default {
  GetModules() {
    return defaultApi({
      method: 'get',
      url: 'check/GetModules',
    });
  },
  GetChoiceModules() {
    return defaultApi({
      method: 'get',
      url: 'check/GetChoiceModules',
    });
  },
  GetUserProfile() {
    return defaultApi({
      method: 'get',
      url: 'check/getuserprofile',
    });
  },
  Login(data) {
    return defaultApi({
      method: 'post',
      url: 'check/login',
      data,
    });
  },
  CheckFuncIdVaild(params) {
    return defaultApi({
      method: 'get',
      url: 'Check/ChkFuncIdValid',
      params,
    });
  },
  CheckInfo(params) {
    return defaultApi({
      method: 'get',
      url: 'Check/ChkInfo',
      params,
    });
  },
  CheckFavorite(params) {
    return defaultApi({
      method: 'get',
      url: 'check/GetFavorite',
      params,
    });
  },
  HandleFavorite(data) {
    return defaultApi({
      method: 'post',
      url: 'check/HandleFavorite',
      data,
    });
  },
};
